export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#8b5cf6]/10 via-transparent to-transparent"></div>
      
      <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <div className="inline-flex items-center gap-2 bg-[#00d9ff]/10 border border-[#00d9ff]/30 px-4 py-2 rounded-full mb-8">
              <div className="w-2 h-2 bg-[#00d9ff] rounded-full animate-pulse"></div>
              <span className="text-[#00d9ff] text-sm font-medium">Open Source Linter Management</span>
            </div>

            <h1 className="text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight font-['Space_Grotesk']">
              Unify Your Lint Rules
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d9ff] to-[#8b5cf6]">
                Across All Projects
              </span>
            </h1>

            <p className="text-xl text-gray-400 mb-10 leading-relaxed max-w-2xl">
              Bellibutton helps developers manage linters with a single rule set that exports to any language. One source of truth for all your code quality standards.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('documentation')}
                className="px-8 py-4 bg-gradient-to-r from-[#00d9ff] to-[#00b8d4] text-black font-semibold rounded-xl hover:shadow-lg hover:shadow-[#00d9ff]/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Started
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="px-8 py-4 bg-white/5 border border-white/10 text-white font-semibold rounded-xl hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Learn More
              </button>
            </div>

            <div className="flex items-center gap-8 mt-12">
              <div>
                <div className="text-3xl font-bold text-white">50K+</div>
                <div className="text-sm text-gray-500">Downloads</div>
              </div>
              <div className="w-px h-12 bg-white/10"></div>
              <div>
                <div className="text-3xl font-bold text-white">12+</div>
                <div className="text-sm text-gray-500">Languages</div>
              </div>
              <div className="w-px h-12 bg-white/10"></div>
              <div>
                <div className="text-3xl font-bold text-white">100+</div>
                <div className="text-sm text-gray-500">Contributors</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#00d9ff] to-[#8b5cf6] rounded-3xl blur-3xl opacity-20"></div>
              <div className="relative bg-[#1a1a1a] border border-white/10 rounded-3xl p-8 backdrop-blur-xl">
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
                <pre className="text-sm font-mono">
                  <code className="text-gray-300">
                    <span className="text-[#8b5cf6]">import</span> <span className="text-[#00d9ff]">{'{'} bellibutton {'}'}</span> <span className="text-[#8b5cf6]">from</span> <span className="text-yellow-400">'bellibutton'</span>;{'\n\n'}
                    <span className="text-gray-500">// Define once, use everywhere</span>{'\n'}
                    <span className="text-[#8b5cf6]">const</span> <span className="text-white">rules</span> = <span className="text-[#00d9ff]">bellibutton</span>.<span className="text-white">create</span>({'({'}{'\n'}
                    {'  '}<span className="text-[#00d9ff]">indent</span>: <span className="text-yellow-400">'2 spaces'</span>,{'\n'}
                    {'  '}<span className="text-[#00d9ff]">quotes</span>: <span className="text-yellow-400">'single'</span>,{'\n'}
                    {'  '}<span className="text-[#00d9ff]">semicolons</span>: <span className="text-yellow-400">true</span>{'\n'}
                    {'}'});{'\n\n'}
                    <span className="text-gray-500">// Export to any language</span>{'\n'}
                    <span className="text-white">rules</span>.<span className="text-[#00d9ff]">export</span>(<span className="text-yellow-400">'eslint'</span>);{'\n'}
                    <span className="text-white">rules</span>.<span className="text-[#00d9ff]">export</span>(<span className="text-yellow-400">'pylint'</span>);{'\n'}
                    <span className="text-white">rules</span>.<span className="text-[#00d9ff]">export</span>(<span className="text-yellow-400">'rustfmt'</span>);
                  </code>
                </pre>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/30 text-2xl"></i>
      </div>
    </section>
  );
}
